import { generateOrganizationSchema } from "@jesus-central-church/schema-org";
import { SbOrganizationSchema } from "@storyblok/types/287435740670216/storyblok-components";

export function OrganizationSchemaComponent({ blok }: { blok: SbOrganizationSchema }) {
    const schema = generateOrganizationSchema({
        name: blok.name,
        url: blok.url.url,
        address: {
            streetAddress: blok.streetAddress,
            postalCode: blok.postalCode,
            addressCountry: blok.addressCountry,
            addressLocality: blok.addressLocality,
            "@type": "PostalAddress",
        },
        telephone: blok.telephone,
    });

    return (
        <script
            id={"organization-schema-" + blok._uid}
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema).replaceAll('<', String.raw`\u003c`),
            }}
        />
    );
}